import React from 'react';
import PropTypes from 'prop-types';

import Popup from '../../Popup';
import styles from './genericPopup.scss';

const GenericPopupWithTwoButtons = ({
    imageSource,
    isError,
    title,
    subtitle,
    disableClickOutside,
    hideCloseIcon,
    shouldSwapButtonOrder,
    primaryButtonText,
    primaryButtonType,
    secondaryButtonText,
    secondaryButtonType,
    onRequestClose,
    onPrimaryButtonClick,
    onSecondaryButtonClick,
    'data-testid': dataTestId,
}) => {
    const handleOnRequestClose = () => {
        onRequestClose();
    };

    const handleOnActionPrimaryButtonClicked = () => {
        onPrimaryButtonClick();
    };

    const handleOnActionSecondaryButtonClicked = () => {
        onSecondaryButtonClick();
    };

    return (
        <Popup
            className="popup-md"
            closeOnClickOutside={disableClickOutside}
            onCloseClick={handleOnRequestClose}
            config={{
                fullScreen: false,
                noPadding: false,
                gradient: true,
                scrollable: false,
                showCloseIcon: !hideCloseIcon,
            }}
        >
            <div className={`${styles.container} container`} data-testid={dataTestId}>
                <div>
                    {imageSource && (
                        <div className="mb10">
                            <img className={styles.image} src={imageSource} data-testid={dataTestId ? `${dataTestId}.image` : undefined} />
                        </div>
                    )}
                    <div className={isError ? styles.titleError : styles.title} data-testid={dataTestId ? `${dataTestId}.title` : undefined}>
                        {title}
                    </div>
                    <div className="mt16 mb16" data-testid={dataTestId ? `${dataTestId}.subtitle` : undefined}>
                        {subtitle}
                    </div>
                    {shouldSwapButtonOrder
                        ? (
                            <div>
                                <button
                                    type="button"
                                    onClick={handleOnActionSecondaryButtonClicked}
                                    className={`btn ${secondaryButtonType} btn-xl text-uppercase`}
                                    data-testid={dataTestId ? `${dataTestId}.secondary-btn` : undefined}
                                >
                                    {secondaryButtonText}
                                </button>
                                <button
                                    type="button"
                                    onClick={handleOnActionPrimaryButtonClicked}
                                    className={`btn ${primaryButtonType} btn-xl text-uppercase ml48`}
                                    data-testid={dataTestId ? `${dataTestId}.primary-btn` : undefined}
                                >
                                    {primaryButtonText}
                                </button>
                            </div>
                        ) : (
                            <div>
                                <button
                                    type="button"
                                    onClick={handleOnActionPrimaryButtonClicked}
                                    className={`btn ${primaryButtonType} btn-xl text-uppercase`}
                                    data-testid={dataTestId ? `${dataTestId}.primary-btn` : undefined}
                                >
                                    {primaryButtonText}
                                </button>
                                <button
                                    type="button"
                                    onClick={handleOnActionSecondaryButtonClicked}
                                    className={`btn ${secondaryButtonType} btn-xl text-uppercase ml48`}
                                    data-testid={dataTestId ? `${dataTestId}.secondary-btn` : undefined}
                                >
                                    {secondaryButtonText}
                                </button>
                            </div>
                        )}
                </div>
            </div>
        </Popup>
    );
};

GenericPopupWithTwoButtons.propTypes = {
    isError: PropTypes.bool,
    disableClickOutside: PropTypes.bool,
    hideCloseIcon: PropTypes.bool,
    shouldSwapButtonOrder: PropTypes.bool,
    imageSource: PropTypes.string,
    title: PropTypes.string.isRequired,
    subtitle: PropTypes.oneOfType([
        PropTypes.element,
        PropTypes.string,
    ]),
    primaryButtonText: PropTypes.string.isRequired,
    primaryButtonType: PropTypes.string,
    secondaryButtonText: PropTypes.string.isRequired,
    secondaryButtonType: PropTypes.string,
    onRequestClose: PropTypes.func,
};

GenericPopupWithTwoButtons.defaultProps = {
    isError: false,
    disableClickOutside: false,
    hideCloseIcon: false,
    shouldSwapButtonOrder: false,
    imageSource: null,
    subtitle: null,
    primaryButtonType: 'btn-primary',
    secondaryButtonType: 'btn-default',
    onRequestClose: () => {},
};

export default GenericPopupWithTwoButtons;
